import { CodeBase } from "./_codeBase";

/** グループ区分*/
export class GroupDiv extends CodeBase<GroupDiv>
{
    /** グループ区分: "01", "1"*/
    public static readonly G_1: GroupDiv = new GroupDiv("01", "1", "");
    /** グループ区分: "02", "2"*/
    public static readonly G_2: GroupDiv = new GroupDiv("02", "2", "");
    /** グループ区分: "03", "3"*/
    public static readonly G_3: GroupDiv = new GroupDiv("03", "3", "");
    /** グループ区分: "04", "4"*/
    public static readonly G_4: GroupDiv = new GroupDiv("04", "4", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): GroupDiv[] {
        return [
            GroupDiv.G_1,
            GroupDiv.G_2,
            GroupDiv.G_3,
            GroupDiv.G_4,
        ];
    }
}
